import { Globe, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { languages } from "../i18n/languages";
import { useLanguage } from "../i18n/LanguageContext";

export function LanguageSwitcher({ mobile = false }) {
  const { language, setLanguage } = useLanguage();
  const current = languages.find((l) => l.code === language);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-switcher-trigger"
          className={`inline-flex items-center gap-1.5 text-sm font-medium text-zinc-400 hover:text-white transition-colors duration-200 ${mobile ? "w-full justify-between py-1" : ""}`}
        >
          <Globe className="w-4 h-4" strokeWidth={1.5} />
          {current?.label || "EN"}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="bg-[#0A0A0C] border-white/10 text-white max-h-72 overflow-y-auto"
        data-testid="language-switcher-menu"
        data-lenis-prevent
      >
        {languages.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => setLanguage(l.code)}
            data-testid={`language-option-${l.code}`}
            className="flex items-center justify-between gap-2 cursor-pointer hover:bg-white/5 focus:bg-white/5"
          >
            {l.label}
            {l.code === language && <Check className="w-4 h-4 text-[#00F0FF]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
